import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const MessageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    border: 1px solid #eee;
    background: #d0d0d012;
`;
